<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="Edit Total Bill"
      maxWidth="500px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-form ref="form" lazy-validation>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-text-field
                label="Period"
                v-model="period"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" >
              <v-text-field
                label="Consultant"
                v-model="consultant"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" >
              <v-text-field
                label="Client"
                v-model="client"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" >
              <FormattedNumberField
                label="Current Total Bill"
                :value="totalBill"
                :readonly="true"
                prepend-inner-icon="attach_money"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="12" sm="6">
              <FormattedNumberField
                label="New Total Bill"
                :value="newTotalBill"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.newTotalBill = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Details"
                v-model="details"
                textarea
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="editTotalBill"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import SimplePageHeader from '@/components/pageComponents/SimplePageHeader'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'
import formatDate from '@/lib/display/formatDate'
import { nextTick } from 'vue'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    FormattedNumberField
  },
  props: [
    'dateBegin',
    'dateEnd',
    'assignmentId',
    'consultant',
    'client',
    'totalBill',
    'totalBillEditedId'
  ],
  data () {
    return {
      showModalProp: false,
      newTotalBill: null,
      details: null
    }
  },
  computed: {
    period () {
      return formatDate(this.dateBegin) + ' - ' + formatDate(this.dateEnd)
    }
  },
  methods: {
    ...mapActions('editedTotalBill', [
      'getEditedTotalBill',
      'saveEditedTotalBill',
      'updateEditedTotalBill'
    ]),
    clearModal () {
      this.newTotalBill = null
      this.details = null
    },
    async showModal () {
      this.clearModal()
      await nextTick()
      if (this.totalBillEditedId) {
        let editedTotalBill = await this.getEditedTotalBill({ id: this.totalBillEditedId })
        this.details = editedTotalBill.details
      }
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.clearModal()
      this.$emit('closeModal')
    },
    async editTotalBill () {
      if (this.$refs.form.validate()) {
        let editedTotalBill = {
          id: this.totalBillEditedId,
          dateBegin: this.dateBegin,
          dateEnd: this.dateEnd,
          assignmentId: this.assignmentId,
          totalBill: this.newTotalBill,
          details: this.details
        }
        if (this.totalBillEditedId) {
          await this.updateEditedTotalBill(editedTotalBill)
        } else {
          await this.saveEditedTotalBill(editedTotalBill)
        }
        this.closeModal()
        this.$emit('editedTotalBill')
        this.newTotalBill = null
        this.details = null
      }
    }
  }
}
</script>
